import { Locale } from './i18n'

/**
 * Return policy URLs by locale
 * Each locale can have its own return policy URL
 * Falls back to the default US URL if no specific URL is provided
 */
export const returnPolicyUrls: Record<Locale, string> = {
	// US English (default)
	'en-us': 'https://help.underarmour.com/s/article/Under-Armour-Return-Policy',

	// Canadian English (same as US)
	'en-ca': 'https://help.underarmour.com/s/article/Under-Armour-Return-Policy',

	// British English
	'en-gb': 'https://www.underarmour.co.uk/en-gb/returnlabel/',
	'en-at': 'https://www.underarmour.at/en-at/returnlabel/',
	'en-be': 'https://www.underarmour.be/en-be/returnlabel/',
	'en-ch': 'https://www.underarmour.ch/en-ch/returnlabel/',
	'en-dk': 'https://www.underarmour.dk/en-dk/returnlabel/',
	'en-my': 'https://www.underarmour.com.my/en-my/returnlabel/',
	'en-no': 'https://www.underarmour.no/en-no/returnlabel/',
	'en-ph': 'https://www.underarmour.com.ph/en-ph/returnlabel/',
	'en-pl': 'https://www.underarmour.pl/en-pl/returnlabel/',
	'en-pt': 'https://www.underarmour.pt/en-pt/returnlabel/',
	'en-se': 'https://www.underarmour.se/en-se/returnlabel/',
	'en-fr': 'https://www.underarmour.fr/en-fr/returnlabel/',
	'en-de': 'https://www.underarmour.de/en-de/returnlabel/',
	'en-es': 'https://www.underarmour.es/en-es/returnlabel/',
	'en-it': 'https://www.underarmour.it/en-it/returnlabel/',
	'en-nl': 'https://www.underarmour.nl/en-nl/returnlabel/',
	'en-ie': 'https://www.underarmour.ie/en-ie/returnlabel/',
	'en-hk': 'https://www.underarmour.hk/en-hk/returnlabel/',
	'en-au': 'https://www.underarmour.com.au/en-au/returnlabel/',
	'en-sg': 'https://www.underarmour.com.sg/en-sg/returnlabel/',
	'en-th': 'https://www.underarmour.co.th/en-th/returnlabel/',
	'en-id': 'https://www.underarmour.co.id/en-id/returnlabel/',
	'en-fi': 'https://www.underarmour.fi/en-fi/returnlabel/',

	// French locales
	'fr-ca': 'https://www.underarmour.ca/fr-ca/returnlabel/',
	'fr-fr': 'https://www.underarmour.fr/fr-fr/returnlabel/',
	'fr-be': 'https://www.underarmour.be/fr-be/returnlabel/',
	'fr-ch': 'https://www.underarmour.ch/fr-ch/returnlabel/',

	// German locales
	'de-de': 'https://www.underarmour.de/de-de/returnlabel/',
	'de-at': 'https://www.underarmour.at/de-at/returnlabel/',
	'de-ch': 'https://www.underarmour.ch/de-ch/returnlabel/',

	// Spanish locales
	'es-es': 'https://www.underarmour.es/es-es/returnlabel/',
	'es-mx': 'https://www.underarmour.com.mx/es-mx/returnlabel/',

	// Italian locales
	'it-it': 'https://www.underarmour.it/it-it/returnlabel/',
	'it-ch': 'https://www.underarmour.ch/it-ch/returnlabel/',

	// Korean
	'ko-kr': 'https://www.underarmour.co.kr/ko-kr/returnlabel/',

	// Dutch locales
	'nl-nl': 'https://www.underarmour.nl/nl-nl/returnlabel/',
	'nl-be': 'https://www.underarmour.be/nl-be/returnlabel/',

	// Polish
	'pl-pl': 'https://www.underarmour.pl/pl-pl/returnlabel/',

	// Chinese (Hong Kong)
	'zh-hk': 'https://www.underarmour.hk/zh-hk/returnlabel/',

	// Thai
	'th-th': 'https://www.underarmour.co.th/th-th/returnlabel/',

	// Portuguese
	'pt-pt': 'https://www.underarmour.pt/pt-pt/returnlabel/',
}

/**
 * Get the return policy URL for a given locale
 * @param locale - The locale to get the return policy URL for
 * @returns The return policy URL for the locale, or the default US URL if not found
 */
export const getReturnPolicyUrl = (locale: Locale): string => {
	return returnPolicyUrls[locale] || returnPolicyUrls['en-us']
}
